export const cssSliderResponsive = {
    prevNextBtnSurveyWrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
        paddingTop: 30,
      },
};
